import _ from 'lodash'
import config from 'scoreboard/components/config'

/**
 * Determines the range of a Y axis on the chart. #41126 if a range is not explicitly
 * defined and all the axis series are backed by scorecard scores, then the range is set
 * to the app-level config (default is 0-10). Otherwise, the range will be based on
 * the min/max values being plotted
 *
 * @param {ChartDesigner} chart
 * @param {'left'|'right'} axis which axis to get the range for
 * @return {min: number, max: number} the range to use for the axis
 */
function getYRange(chart, axis) {
	// First check if we have static values set
	let min = chart.get(`${axis}AxisMin`)
	let max = chart.get(`${axis}AxisMax`)

	if (min && max) return { min, max }

	// If a value is not defined, check the type of all serie sources on the axis
	const series = chart.getFeatures({ axis, type: 'serie' })

	if (series.length == 0) {
		// #43115 if there are no series on the axis, just let the chart
		// module use its default behavior
		return { min: null, max: null }
	}

	const isNotScorecardSource = s => {
		const dataSource = s.get('source')
		return !dataSource || dataSource.domainType !== 'scorecard-item' ||
			dataSource.dataProperty !== 'score'
	}

	if (_.some(series, isNotScorecardSource)) {
		// If there are any non-score sources, we can't force app config's min/max
		return { min, max }
	}

	if (_.some(chart.features.toArray(), f => f.get('type') === 'stack')) {
		// If there are any stacks, we can't force app config's min/max
		return { min, max }
	}

	// #41126 we know that all sources are scorecards and we are plotting scores,
	// and there are no stack features (#41491), so we want to set the axis range
	// to the app configured score range (default is 0-10, but that can be changed)
	// BUT only force min/max if scores can't exceed the app config range
	if (!min && !config.allowScoresBelowMin) {
		min = config.minimumScore
	}
	if (!max && !config.allowScoresAboveMax) {
		max = config.maximumScore
	}
	return { min, max }
}

export default getYRange

getYRange.__filename__ = 'charts/chart-data/get-y-range.js'
